module.exports = {
  runtime: 'prod',
  site: {
    publicPath: 'https://s.vipkidstatic.com/fe-static/hobbit-sa-school/prod/', // 静态资源部署目录
    routerBase: '/', // 网站路由基础路径
    routerMode: 'history',
    outputDir: 'dist/prod',
    vconsole: false,
    visualScrollbar: true,
    sessionIDKey: 'sessionid',
    deviceIDKey: 'deviceid',
    pageRecordsKey: 'vkpage', // 记录当前页面名称到SS中的key
    bizKey: 'biz',
    langKey: 'lang',
    supportBizs: [ // 支持的国家码
      { biz: 'sa' },
    ],
    supportLangs: [
      { lang: 'ar-sa', text: 'العربية', pcAppLangCode: 4 },
      { lang: 'en-us', text: 'English', pcAppLangCode: 0 },
    ],
  },
  resources: {
    file: 'https://s.vipkidstatic.com/fe-static/int/translate/prod_{appName}_{lang}.js',
    cacheExpires: 10 * 60 * 1000, // 资源缓存刷新间隔时间（毫秒数）
    commonModule: 'app', // 全局公共模块名
    callbackMethod: 'HobbitResourcesCallback', // 全局安装函数（JSONP用）
  },
  user: {
    tokenKey: 'token',
    userIdKey: 'vkuserid',
    studentIdKey: 'vkstudentid',
    tokenRecheckSeconds: 20 * 60,
  },
  log: {
    saSDK: 'https://s.vipkidstatic.com/fe-static/hobbit/asset/lib/sensorsdata.1.16.1.min.js',
    saUrl: 'https://sensorsdata.vipkid.com/sa?project=misc',
    product: 'intl',
    appName: 'hobbit-sa-school',
    channelKey: 'channel', // URL中设置渠道的参数key
    channelLevelKey: 'chlevel', // URL中设置的渠道级别
    referralKey: 'referralcode', // URL中设置转介绍参数key
    consoleLog: false,
    defaultApiLogSampling: 10, // 默认api监控统计抽样率
  },
  fetch: {
    baseUrl: '',
    defaultTimeout: 1e4,
    cacheStoreName: 'FetchCache',
    maxCacheCount: 50, // <=0则禁用缓存
    retryDelay: 1200, // <=0则禁用
    defaultOnlineCacheExpires: 60 * 1000,
    defaultOfflineCacheExpires: 3600 * 1000,
    withCredentials: false, // 默认跨域鉴权开关
    idem: true, // 幂等请求
    mock: false, // 生产环境任何时刻都不建议开启mock测试，请保持关闭状态
  },
  routes: {
    /* 路由示例
      页面Id: {
        index: 页序（非0值）, path: 访问路径, view: 默认视图vue文件路径, mview: M视图文件, padview: Pad视图文件
        , keepAlive: 是否启用页面缓存, preloads: [预加载的页面Key], pv: 自动pv上报名（false则不上报）
      }
    */
    // #region 官网页面
    home: {
      index: 1, path: '/([a-z]{2}-[a-z]{2})?/', view: '/home/home.vue', mview: '/home/m_home.vue', preloads: ['signin', 'signup'],
    },
    intro_howitworks: {
      index: 2, path: '/([a-z]{2}-[a-z]{2})/how-it-works/', view: '/intro/howitworks/howitworks.vue', mview: '/intro/howitworks/m_howitworks.vue',
    },
    intro_ourteachers: {
      index: 3, path: '/([a-z]{2}-[a-z]{2})/our-teachers/', view: '/intro/ourteachers/ourteachers.vue', mview: '/intro/ourteachers/m_ourteachers.vue',
    },
    intro_purchase: {
      index: 4, path: '/([a-z]{2}-[a-z]{2})/pricing/', view: '/intro/purchase/purchase.vue', mview: '/intro/purchase/m_purchase.vue',
    },
    // #endregion
    // #region 订单相关
    order: {
      index: 40, path: '/([a-z]{2}-[a-z]{2})/purchase/order/', view: '/ucenter/purchase/order/order.vue', mview: '/ucenter/purchase/order/m_order.vue',
    },
    order_detail: {
      index: 41, path: '/([a-z]{2}-[a-z]{2})/purchase/order/detail/', view: '/ucenter/purchase/orderDetail/orderDetail.vue', mview: '/ucenter/purchase/orderDetail/m_orderDetail.vue',
    },
    order_checkout: {
      index: 42, path: '/([a-z]{2}-[a-z]{2})/purchase/order/checkout/', view: '/ucenter/purchase/orderCheckout/orderCheckout.vue', mview: '/ucenter/purchase/orderCheckout/m_orderCheckout.vue',
    },
    order_pay: {
      index: 43, path: '/([a-z]{2}-[a-z]{2})/purchase/order/pay/', view: '/ucenter/purchase/orderPay/orderPay.vue', mview: '/ucenter/purchase/orderPay/m_orderPay.vue',
    },
    bill: {
      index: 44, path: '/([a-z]{2}-[a-z]{2})/bill/', view: '/ucenter/bill/bill.vue',
    },
    // #endregion
    // #region 账户信息相关
    signup: {
      index: 1010, path: '/([a-z]{2}-[a-z]{2})/signup/', view: '/user/signup/signup.vue', preloads: ['signin'],
    },
    signin: {
      index: 1020, path: '/([a-z]{2}-[a-z]{2})/signin/', view: '/user/signin/signin.vue', preloads: ['signup'],
    },
    thanks_page: {
      index: 1030, path: '/([a-z]{2}-[a-z]{2})/thankspage/', view: '/user/thanksPage/thanksPage.vue',
    },
    userinfo: {
      index: 20, path: '/([a-z]{2}-[a-z]{2})/ucenter/info/', view: '/ucenter/info/info.vue', mview: '/ucenter/info/m_info.vue',
    },
    // referral: {
    //   index: 21, path: '/([a-z]{2}-[a-z]{2})/referral/', view: '/service/referral/referral.vue', mview: '/service/referral/m-referral.vue',
    // },
    // #endregion
    homeroom: {
      index: 30, path: '/([a-z]{2}-[a-z]{2})/homeroom/', view: '/ucenter/homeroom/homeroom.vue',
    },
    // #region 约课相关页面
    // 约课-试听课 timeslot 页面
    booktrailclass: {
      index: 41, path: '/([a-z]{2}-[a-z]{2})/ucenter/bookclass/trial/', view: '/ucenter/bookclass/trailtimeslot/trailtimeslot.vue', mview: '/ucenter/bookclass/trailtimeslot/m_trailtimeslot.vue', preloads: ['trailteacherlist', 'bookmajorclass'],
    },
    // 试听课 ts 选老师页面
    trailteacherlist: {
      index: 42, path: '/([a-z]{2}-[a-z]{2})/ucenter/bookclass/trial/techers/', view: '/ucenter/bookclass/trailteacherlist/trailteacherlist.vue', mview: '/ucenter/bookclass/trailteacherlist/m_trailteacherlist.vue', preloads: ['trailteacherlist', 'bookmajorclass', 'trailtecherdetail'],
    },
    // 试听课 ts 老师详情
    trailtecherdetail: {
      index: 42, path: '/([a-z]{2}-[a-z]{2})/ucenter/bookclass/trial/techerdetail/', view: '/ucenter/bookclass/trailtecherdetail/trailtecherdetail.vue', mview: '/ucenter/bookclass/trailtecherdetail/m_trailtecherdetail.vue', preloads: ['booktrailclass', 'trailteacherlist', 'bookmajorclass'],
    },
    // 主修课 byts 页面
    bookmajorclass: {
      index: 41, path: '/([a-z]{2}-[a-z]{2})/ucenter/bookclass/major/', view: '/ucenter/bookclass/majortimeslot/majortimeslot.vue', mview: '/ucenter/bookclass/majortimeslot/m_majortimeslot.vue', preloads: ['booktrailclass', 'majortsteachers', 'majorautobook'],
    },
    // 主修课 byts 选老师 页面
    majortsteachers: {
      index: 42, path: '/([a-z]{2}-[a-z]{2})/ucenter/bookclass/major/tsteachers/', view: '/ucenter/bookclass/majortsteachers/majortsteachers.vue', mview: '/ucenter/bookclass/majortsteachers/m_majortsteachers.vue', preloads: ['booktrailclass', 'bookmajorclass', 'majorautobook'],
    },
    // 主修课by ts 老师详情
    majortimeslotdetail: {
      index: 42, path: '/([a-z]{2}-[a-z]{2})/ucenter/bookclass/major/timeslotdetail/', view: '/ucenter/bookclass/majortimeslotdetail/majortimeslotdetail.vue', mview: '/ucenter/bookclass/majortimeslotdetail/m_majortimeslotdetail.vue', preloads: ['booktrailclass', 'bookmajorclass', 'majorautobook', 'majortsteachers'],
    },
    // 主修课 by teacher 老师列表
    majorteachers: {
      index: 41, path: '/([a-z]{2}-[a-z]{2})/ucenter/bookclass/major/teachers/', view: '/ucenter/bookclass/majorteachers/majorteachers.vue', mview: '/ucenter/bookclass/majorteachers/m_majorteachers.vue', preloads: ['booktrailclass', 'bookmajorclass', 'majorautobook'],
    },
    // 主修课 by teacher 老师详情
    majortdetail: {
      index: 42, path: '/([a-z]{2}-[a-z]{2})/ucenter/bookclass/major/teachersdetail/', view: '/ucenter/bookclass/majortdetail/majortdetail.vue', mview: '/ucenter/bookclass/majortdetail/m_majortdetail.vue', preloads: ['booktrailclass', 'bookmajorclass', 'majorautobook', 'majorteachers'],
    },
    // 主修课 by teacher 老师约课
    majorteachertimeslot: {
      index: 42, path: '/([a-z]{2}-[a-z]{2})/ucenter/bookclass/major/timeslot/', view: '/ucenter/bookclass/majorteachertimeslot/majorteachertimeslot.vue', mview: '/ucenter/bookclass/majorteachertimeslot/m_majorteachertimeslot.vue', preloads: ['booktrailclass', 'bookmajorclass', 'majorautobook', 'majorteachers', 'majortdetail'],
    },
    // 自动约课计划
    majorautobook: {
      index: 43, path: '/([a-z]{2}-[a-z]{2})/ucenter/bookclass/major/autobook/', view: '/ucenter/bookclass/majorautobook/majorautobook.vue', preloads: ['booktrailclass', 'majortsteachers', 'bookmajorclass'],
    },
    // m端主修课入口页面
    majorentry: {
      index: 41, path: '/([a-z]{2}-[a-z]{2})/ucenter/bookclass/major/entry/', mview: '/ucenter/bookclass/majorentry/majorentry.vue', preloads: ['bookmajorclass', 'majortsteachers', 'majorautobook'],
    },
    // m端搜索老师页
    majorteachersearch: {
      index: 42, path: '/([a-z]{2}-[a-z]{2})/ucenter/bookclass/major/search/', mview: '/ucenter/bookclass/majorteachersearch/majorteachersearch.vue', preloads: ['majortsteachers', 'majortdetail', 'majortimeslotdetail'],
    },
    // 老师详情页 老页面迁移
    teacherdetail: {
      index: 43, path: '/([a-z]{2}-[a-z]{2})/ucenter/teachersdetail/', view: '/ucenter/teacher/detail/detail.vue', mview: '/ucenter/teacher/detail/m_detail.vue',
    },
    // #endregion
    // #region 优惠券相关
    couponbox: {
      index: 50, path: '/([a-z]{2}-[a-z]{2})/ucenter/couponbox/', view: '/ucenter/coupon/couponbox.vue',
    },
    courseoverview: {
      index: 60, path: '/([a-z]{2}-[a-z]{2})/ucenter/course/(overview/)?', view: '/ucenter/course/overview/overview.vue',
    },
    exchange: {
      index: 70, path: '/([a-z]{2}-[a-z]{2})/ucenter/exchange/', view: '/ucenter/exchange/exchange.vue',
    },
    // #endregion
    // #region 辅助页面
    trialres: {
      index: 91, path: '/([a-z]{2}-[a-z]{2})/trialres/', view: '/ucenter/trialres/trialres.vue',
    },
    downloads: {
      index: 25, path: '/([a-z]{2}-[a-z]{2})/downloads/', view: '/service/downloads/index.vue', mview: '/service/downloads/m_index.vue',
    },
    ittest: {
      index: 1030, path: '/([a-z]{2}-[a-z]{2})/ittest/', view: '/service/ittest/ittest.vue',
    },
    cmshtml: {
      index: 80, path: '/([a-z]{2}-[a-z]{2})/cms/html/', view: '/service/cms/html.vue',
    },
    preload: {
      index: -10, path: '/([a-z]{2}-[a-z]{2})/preload/', view: '/service/preload/preload.vue', pv: false,
    },
    error404: {
      index: 404, path: '*', view: '/service/error404/error404.vue',
    },
    classfeedback: {
      index: 60,
      path: '/([a-z]{2}-[a-z]{2})/classfeedback/',
      view: '/ucenter/course/classfeedback/mclassfeedback.vue',
      mview: '/ucenter/course/classfeedback/mclassfeedback.vue',
    },
    // #endregion
  },
  abtest: {
    // 注册v2(带定级问题)
    // signupV2: {
    //   times: [
    //     {
    //       begin: '2021/04/01', // 本地时间（避免时区问题可以写时间戳）
    //       end: '2099/12/30',
    //       seg: [10, 45, 45],
    //     },
    //   ],
    // },
  },
  // 业务自定义配置信息
  custom: {
    // === 普通配置 ===
    faqIMUrl: 'https://www.vipkid.com/{lang}/faqim/',
    // === 禁用IM的路由 ===
    disableIMRoutes: {
      pc: [
        'signup',
        'signin',
        'preload',
        'bill',
        'order',
        'order_detail',
        'order_checkout',
        'order_pay',
        'trialres',
        'thankful',
        'double12',
        'double12langding',
        'classfeedback',
      ],
      m: [
        'signup',
        'signin',
        'preload',
        'bill',
        'order',
        'order_detail',
        'order_checkout',
        'order_pay',
        'trialres',
        'thankful',
        'double12',
        'double12langding',
        'booktrailclass',
        'trailteacherlist',
        'bookmajorclass',
        'majortsteachers',
        'majortimeslotdetail',
        'majorentry',
        'majorteachers',
        'majortdetail',
        'majorteachertimeslot',
        'majorteachersearch',
        'classfeedback',
      ],
    },
    facebook: {
      SDK_URL: 'https://connect.facebook.net/en_US/sdk.js',
      appId: '861697761215854',
    },
    google: {
      SDK_URL: 'https://apis.google.com/js/platform.js',
      client_id: '676572178122-sabukf1gaooja9cia7h13gs990ttr8l3.apps.googleusercontent.com',
    },
    downloads: {
      studyCenter: {
        windows: 'https://dl.vipkidstatic.com/vcp/pc-container/international/student/win/1.0.1/VIPKIDINTL-v1.0.1-win-ia32.exe',
        mac: 'https://dl.vipkidstatic.com/vcp/pc-container/international/student/mac/1.0.1/VIPKID-v1.0.1-mac-x64.dmg',
        android: 'https://s.vipkidstatic.com/fe-static/hobbit/asset/res/downloads/VIPKID_Study_Center_v1_1_1.apk',
        ios: 'https://itunes.apple.com/kr/app/vipkid-study-center/id1423521190',
      },
    },
    cmsApiBase: '/rest/gw/lgb/api/cms',
    currencyMaps: {
      USD: '$',
      HKD: 'HK$',
      CNY: '￥',
      SAR: 'ريال',
    },
    airwallex: {
      fontUrl: 'https://checkout.airwallex.com/fonts/CircularXXWeb/CircularXXWeb-Regular.woff2', // airwallex 支付平台字体url
      sdkUrl: 'https://checkout.airwallex.com/assets/elements.bundle.min.js',
    },
    mPayPageSupportPayMehod: [5, 6, 7], // 支付页支持的支付方式 // 5 信用卡 6 微信 7 支付宝 手机端暂不支持 paypal
    whiteListTagID: 290,
    // cms key 集合
    cmsKeyMaps: {
      privacyKey: 'L0J6QD6S2MH4KEEP', // cms 隐私政策 key
      productContractKeyPrefix: 'SA_PRODUCT_CONTRACT_', // cms 商品合同Key 前缀
      bookclassBanner: {
        'ar-sa': 'KZZDAE6U1MR5D9AO',
      },
    },
    thanksPageTo: '/student/home/',
  },
};
